import { render, staticRenderFns } from "./createBusM.vue?vue&type=template&id=06c97cd6&scoped=true&"
import script from "./createBusM.vue?vue&type=script&lang=js&"
export * from "./createBusM.vue?vue&type=script&lang=js&"
import style0 from "./createBusM.vue?vue&type=style&index=0&id=06c97cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c97cd6",
  null
  
)

export default component.exports